import { Router } from "../router";

export const router = new Router<any>();

// See agent/agent/api/producers/session.py's session_producer -- streams every
// mutation of agent_connection.session (RFC 6902 ops, via common._ObservableMixin.
// stream_changes()) live over the websocket. All ops produced by one synchronous
// Python mutation are batched together and applied in a single runInAction (via
// agent_store.ts dispatch wrapper) so no intermediate state ever reaches React.
router.on("session_change_batch", (data, ctx) => {
    for (const op of data.ops) {
        ctx.agent.session.applyPatch(op);
    }
});
